import api from './api';

const signedContractService = {
  // Get all signed contracts
  getAllSignedContracts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.contractType) queryParams.append('contractType', params.contractType);
      if (params.partyId) queryParams.append('partyId', params.partyId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.expiringSoon) queryParams.append('expiringSoon', params.expiringSoon);

      const queryString = queryParams.toString();
      const url = `/signed-contract${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching signed contracts:', error);
      throw error;
    }
  },

  // Get signed contract by ID
  getSignedContractById: async (id) => {
    try {
      const response = await api.get(`/signed-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching signed contract:', error);
      throw error;
    }
  },

  // Get next contract number
  getNextContractNumber: async () => {
    try {
      const response = await api.get('/signed-contract/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next contract number:', error);
      throw error;
    }
  },

  // Create signed contract
  createSignedContract: async (contractData) => {
    try {
      const response = await api.post('/signed-contract', contractData);
      return response.data;
    } catch (error) {
      console.error('Error creating signed contract:', error);
      throw error;
    }
  },

  // Sign contract from draft
  signContractFromDraft: async (draftContractId, signingData) => {
    try {
      const response = await api.post(`/signed-contract/sign-from-draft/${draftContractId}`, signingData);
      return response.data;
    } catch (error) {
      console.error('Error signing contract from draft:', error);
      throw error;
    }
  },

  // Update signed contract
  updateSignedContract: async (id, contractData) => {
    try {
      const response = await api.put(`/signed-contract/${id}`, contractData);
      return response.data;
    } catch (error) {
      console.error('Error updating signed contract:', error);
      throw error;
    }
  },

  // Delete signed contract
  deleteSignedContract: async (id) => {
    try {
      const response = await api.delete(`/signed-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting signed contract:', error);
      throw error;
    }
  },

  // Get signed contract statistics
  getSignedContractStats: async () => {
    try {
      const response = await api.get('/signed-contract/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching signed contract statistics:', error);
      throw error;
    }
  }
};

export default signedContractService;

